import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iCreditAdjustmentsState {
    isLoading : boolean;
    response : any;
}

const initialState:iCreditAdjustmentsState = {
    isLoading : false,
    response : []
}

export const getCreditAdjustmentsAPI = createAsyncThunk(
    "GET_CREDIT_ADJUSTMENTS",
    async (user : {target_email:string; action:string; amount:number; reason:string ; idempotency_key:string}, { rejectWithValue }) => {
        const djangoEndpoint = getDjangoEndpoint();

        try {
            const pathParam = '/A7fQ9K2mXcP4R8sL/admin/adjustments/'
            const response = await axios.post(`${djangoEndpoint}${pathParam}`,{
                target_email : user.target_email,
                action : user.action,
                amount : user.amount,
                reason : user.reason,
                idempotency_key : user.idempotency_key
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (e) {
            console.error('Credit Adjustments API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const creditAdjustmentsSlice = createSlice({
    name: 'creditAdjustments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCreditAdjustmentsAPI.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getCreditAdjustmentsAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getCreditAdjustmentsAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.response = action.payload; 
        })
    }
})

export default creditAdjustmentsSlice.reducer;